import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core'

@Component({
  selector: 'lin-layout-form-sections-wrapper lin-layout-form-section',
  template: ` <ng-content></ng-content> `,
  styleUrls: ['./form-section.component.scss'],
  standalone: false,
})
export class FormSectionComponent {
  @HostBinding('class.double')
  get double() {
    return this.layout === 'double'
  }

  @HostBinding('class.triple')
  get triple() {
    return this.layout === 'triple'
  }

  @Input() layout: 'double' | 'triple'
}
